export const publishNewRelicPageAction = ({ actionName = '', actionObject = {} }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('gift-cards.pageAction', { actionName, actionObject });
  }
};

export const publishNewRelicCustomAttribute = ({ tagName, tagValue }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('gift-cards.customTag', { tagName, tagValue });
  }
};

export const publishNewRelicNoticeError = ({ tagName, tagValue }) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger('gift-cards.noticeError', { tagName, tagValue });
  }
};
